<template>
    <div class="sidebar-detail__section">
       <div class="sidebar__section sidebar-detail__subtitle bold-small-label">
           Meldungen
       </div>
       <div class="sidebar__section route-message-alert">
            <div class="route-message-alert__item" v-for="(message, index) in routeOperationMessages.messages" :key="index">
                <img :src="`${publicPath}/images/ui/alert.svg`" class="route-message-alert__icon" />
                <div class="route-message-alert__texts">
                    <div>{{ message.title }}</div>
                    <div class="copy-light" v-html="message.text"></div>
                </div>
            </div>
       </div>
    </div>
</template>

<script>
    export default {
        props: {
            routeOperationMessages: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
            }
        }
    }
</script>
<style lang="scss">
    .route-message-alert {
        $block: &;
        display: flex; 
        flex-direction: column;
        padding-right: 0;

        &__item {
            display: flex;
            align-items: flex-start;

        }

        &__texts {
            border-bottom: 1px solid $color-black-005;
            padding:  10px 16px 10px 0;
            flex: 1;
        }

        &__icon {
            margin-right: 16px;
            margin-top: 16px;
        }
    }
</style>